module.exports = __webpack_public_path__ + "static/media/github.0ba2aa20.png";